// React
import React from "react";

// Third party imports
import { ErrorBoundary } from "react-error-boundary";

import { resolveView } from "./blockUtils";
import {
  CompaniesBlock,
  CompanyCardBlock,
  NotesBlock,
  NotificationsBlock,
  OperatorsBlock,
  PaymentsSummaryBlock,
} from "./CrmBlocks";
import {
  CompanyServicesBlock,
  CompanySubtasksBlock,
  CompanyTasksBlock,
  MySubtasksBlock,
} from "./WorkBlocks";

// One renderer per projectable tool (contract section 3). Unknown tools render nothing.
const RENDERERS = {
  search_companies: CompaniesBlock,
  get_company: CompanyCardBlock,
  list_company_tasks: CompanyTasksBlock,
  list_company_subtasks: CompanySubtasksBlock,
  list_my_subtasks: MySubtasksBlock,
  list_company_notes: NotesBlock,
  list_company_services: CompanyServicesBlock,
  my_notifications: NotificationsBlock,
  list_operators: OperatorsBlock,
  company_payments_summary: PaymentsSummaryBlock,
};

/**
 * Generative UI block of a reply: read-only view of a tool result ({ tool, data }), built from
 * the data and never from the model's text. Links navigate in the app through onNavigate.
 * variant "panel" is compact (5 rows + "Mostra tutti"), "page" shows everything.
 */
export default function AiBlock({ block, view, variant = "panel", onNavigate }) {
  const Renderer = block && RENDERERS[block.tool];
  if (!Renderer || !block.data || typeof block.data !== "object") return null;
  return (
    // Unexpected data must not take the conversation down with it
    <ErrorBoundary fallback={null}>
      <Renderer
        data={block.data}
        view={resolveView(block.tool, view)}
        variant={variant}
        onNavigate={onNavigate}
      />
    </ErrorBoundary>
  );
}
